import { NumberSuffixTranslateEnum } from '@shared/enums/number-suffix-translate.enum'
import { NumericAbbreviationInterface } from '@shared/interfaces/number-abbreviation.interface'

export const NumericAbbreviations: NumericAbbreviationInterface[] = [
	{ value: 1e3, suffix: NumberSuffixTranslateEnum.K },
	{ value: 1e6, suffix: NumberSuffixTranslateEnum.M },
	{ value: 1e9, suffix: NumberSuffixTranslateEnum.B },
	{ value: 1e12, suffix: NumberSuffixTranslateEnum.T },
]
